import moment from "moment";
import Style from "./TransactionBox.module.scss"

const TransactionBox=({data})=>{
    const isDebited = data?.status == "withdraw"
    return(
        <>      
            <div className={Style.t_container}>
                <div className={Style.t_box1}>
                    <p className={Style.text1}>{data?.status == "refund" ? "Refund for Gift Card":data?.challenge_id?.challenge_name||"Gift Card"}</p>
                    <p className={Style.text2}>{`Completed on ${moment.utc(data?.created_at).format("D MMMM YYYY")}`}</p>
                </div>
                <div className={Style.t_box2}>
                    <p className={Style.text3}>{isDebited ? "Debited" : "Credited"}</p>
                    <p className={Style.text4} style={{color :isDebited? "#FF91A4" : "#21CF60"}}>{isDebited ? "-" : "+"}{data?.reward_amt || 0}</p>
                </div>
            </div>
        </>
    )
}
export default TransactionBox;